import isValueEmpty from '../../isValueEmpty';

export const errorMessage = __('This field is too short (min: %{minLength})');

export const validateMinLength = (value, minLength) => {
  let error;

  if (isValueEmpty(value)) {
    return error;
  }

  if (value.length < minLength) {
    error = errorMessage.i__({
      minLength,
    });
  }

  return error;
};
